/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenderComposition } from './GenderComposition';
import {
    GenderCompositionFromJSON,
    GenderCompositionFromJSONTyped,
    GenderCompositionToJSON,
    GenderCompositionToJSONTyped,
} from './GenderComposition';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { ClassDayRequest } from './ClassDayRequest';
import {
    ClassDayRequestFromJSON,
    ClassDayRequestFromJSONTyped,
    ClassDayRequestToJSON,
    ClassDayRequestToJSONTyped,
} from './ClassDayRequest';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateClassRequest
 */
export interface UpdateClassRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateClassRequest
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateClassRequest
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateClassRequest
     */
    classStartDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateClassRequest
     */
    minAge: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateClassRequest
     */
    maxAge: number;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateClassRequest
     */
    locationId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {GenderComposition}
     * @memberof UpdateClassRequest
     */
    genderComposition: GenderComposition;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    isContinuous: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    requiresApproval: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    hasWaitList: boolean | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateClassRequest
     */
    classEndDate: any | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClassRequest
     */
    classStartTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClassRequest
     */
    classEndTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    allowOnlineRegistration?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    billSeparately?: boolean | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateClassRequest
     */
    maxNumberOfStudents?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    hideOnLiveSchedule?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    recital?: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof UpdateClassRequest
     */
    tuition?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof UpdateClassRequest
     */
    registrationFee?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    applySeasonRegistrationFee?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClassRequest
     */
    description?: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateClassRequest
     */
    classRoomId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateClassRequest
     */
    seasonId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateClassRequest
     */
    tuitionRatePlanId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    prorateTuition?: boolean | null;
    /**
     * 
     * @type {Array<ClassDayRequest>}
     * @memberof UpdateClassRequest
     */
    classDays?: Array<ClassDayRequest> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateClassRequest
     */
    tuitionDiscountIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    isFeatured?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRequest
     */
    offersMakeup?: boolean | null;
}



/**
 * Check if a given object implements the UpdateClassRequest interface.
 */
export function instanceOfUpdateClassRequest(value: object): value is UpdateClassRequest {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('classStartDate' in value) || value['classStartDate'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('minAge' in value) || value['minAge'] === undefined) return false;
    if (!('maxAge' in value) || value['maxAge'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('genderComposition' in value) || value['genderComposition'] === undefined) return false;
    if (!('isContinuous' in value) || value['isContinuous'] === undefined) return false;
    if (!('requiresApproval' in value) || value['requiresApproval'] === undefined) return false;
    if (!('hasWaitList' in value) || value['hasWaitList'] === undefined) return false;
    if (!('classEndDate' in value) || value['classEndDate'] === undefined) return false;
    return true;
}

export function UpdateClassRequestFromJSON(json: any): UpdateClassRequest {
    return UpdateClassRequestFromJSONTyped(json, false);
}

export function UpdateClassRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClassRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'name': json['name'],
        'classStartDate': (new Date(json['classStartDate'])),
        'isActive': json['isActive'],
        'minAge': json['minAge'],
        'maxAge': json['maxAge'],
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
        'genderComposition': GenderCompositionFromJSON(json['genderComposition']),
        'isContinuous': json['isContinuous'],
        'requiresApproval': json['requiresApproval'],
        'hasWaitList': json['hasWaitList'],
        'classEndDate': json['classEndDate'],
        'classStartTime': json['classStartTime'] == null ? undefined : json['classStartTime'],
        'classEndTime': json['classEndTime'] == null ? undefined : json['classEndTime'],
        'allowOnlineRegistration': json['allowOnlineRegistration'] == null ? undefined : json['allowOnlineRegistration'],
        'billSeparately': json['billSeparately'] == null ? undefined : json['billSeparately'],
        'maxNumberOfStudents': json['maxNumberOfStudents'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['maxNumberOfStudents']),
        'hideOnLiveSchedule': json['hideOnLiveSchedule'] == null ? undefined : json['hideOnLiveSchedule'],
        'recital': json['recital'] == null ? undefined : json['recital'],
        'tuition': json['tuition'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['tuition']),
        'registrationFee': json['registrationFee'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['registrationFee']),
        'applySeasonRegistrationFee': json['applySeasonRegistrationFee'] == null ? undefined : json['applySeasonRegistrationFee'],
        'description': json['description'] == null ? undefined : json['description'],
        'classRoomId': json['classRoomId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['classRoomId']),
        'seasonId': json['seasonId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['seasonId']),
        'tuitionRatePlanId': json['tuitionRatePlanId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['tuitionRatePlanId']),
        'prorateTuition': json['prorateTuition'] == null ? undefined : json['prorateTuition'],
        'classDays': json['classDays'] == null ? undefined : ((json['classDays'] as Array<any>).map(ClassDayRequestFromJSON)),
        'tuitionDiscountIds': json['tuitionDiscountIds'] == null ? undefined : json['tuitionDiscountIds'],
        'isFeatured': json['isFeatured'] == null ? undefined : json['isFeatured'],
        'offersMakeup': json['offersMakeup'] == null ? undefined : json['offersMakeup'],
    };
}

export function UpdateClassRequestToJSON(json: any): UpdateClassRequest {
    return UpdateClassRequestToJSONTyped(json, false);
}

export function UpdateClassRequestToJSONTyped(value?: UpdateClassRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'name': value['name'],
        'classStartDate': value['classStartDate'].toISOString().substring(0,10),
        'isActive': value['isActive'],
        'minAge': value['minAge'],
        'maxAge': value['maxAge'],
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
        'genderComposition': GenderCompositionToJSON(value['genderComposition']),
        'isContinuous': value['isContinuous'],
        'requiresApproval': value['requiresApproval'],
        'hasWaitList': value['hasWaitList'],
        'classEndDate': value['classEndDate'],
        'classStartTime': value['classStartTime'],
        'classEndTime': value['classEndTime'],
        'allowOnlineRegistration': value['allowOnlineRegistration'],
        'billSeparately': value['billSeparately'],
        'maxNumberOfStudents': ActorActivityRecordActorUserIdToJSON(value['maxNumberOfStudents']),
        'hideOnLiveSchedule': value['hideOnLiveSchedule'],
        'recital': value['recital'],
        'tuition': BalanceUnitStatementEntryDebitToJSON(value['tuition']),
        'registrationFee': BalanceUnitStatementEntryDebitToJSON(value['registrationFee']),
        'applySeasonRegistrationFee': value['applySeasonRegistrationFee'],
        'description': value['description'],
        'classRoomId': ActorActivityRecordActorUserIdToJSON(value['classRoomId']),
        'seasonId': ActorActivityRecordActorUserIdToJSON(value['seasonId']),
        'tuitionRatePlanId': ActorActivityRecordActorUserIdToJSON(value['tuitionRatePlanId']),
        'prorateTuition': value['prorateTuition'],
        'classDays': value['classDays'] == null ? undefined : ((value['classDays'] as Array<any>).map(ClassDayRequestToJSON)),
        'tuitionDiscountIds': value['tuitionDiscountIds'],
        'isFeatured': value['isFeatured'],
        'offersMakeup': value['offersMakeup'],
    };
}

